module.exports = __webpack_public_path__ + "static/media/platform-bg.ea23c5e1.jpeg";